<!-- Add Deposits Modal  -->

<form [formGroup]="depositOccurenceForm" (ngSubmit)="SaveDeposit()">
  <!-- Modal Header -->
  <div class="p-3 flex align-items-center justify-content-between surface-0 sticky left-0 bottom-0 w-full z-1 border-bottom-1 border-300">
      <h2 class="mb-0 text-sm">{{'DEPOSIT.NAME' | translate}}</h2>
      <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeDialog()"></i>
  </div>
  <!-- Modal Header -->

  <!-- Modal Content -->
  <div class="p-3 surface-100">
      <!-- Tabs for Desktop -->
      <div class="p-buttonset hidden md:block justify-content-center">
          <button
              pButton
              pRipple
              type="button"
              *ngFor="let occurence of occurenctType"
              class="text-sm w-4-sm border-right-1 border-white hover:text-white"
              [ngClass]="{'border-white': occurence.value === SelectedOccurenceTypeFormControl.value.value,'p-button-secondary ml-1': occurence.value !== SelectedOccurenceTypeFormControl.value.value}"
              (click)="SelectedOccurenceTypeFormControl = occurence"
              [label]="'DEPOSIT.'+occurence.value | translate"
          ></button>
          <app-error-msg
              *ngIf=" SelectedOccurenceTypeFormControl?.touched && SelectedOccurenceTypeFormControl?.invalid "
              [errors]="SelectedOccurenceTypeFormControl?.errors"
              [fieldLabel]="'DEPOSIT.OCCURENCE_TYPE' | translate"
          ></app-error-msg>
      </div>
      <!-- Tabs for Desktop -->

      <!-- Selectbox for Mobile -->
      <div class="md:hidden mt-2">
          <p-select [options]="occurenctType" optionLabel="value" formControlName="occurence_type" filterBy="value" styleClass="w-full text-sm"
             >
              <ng-template pTemplate="selectedItem">
                  <div class="text-sm" *ngIf="SelectedOccurenceTypeFormControl.value">{{SelectedOccurenceTypeFormControl.value.value}}</div>
              </ng-template>
              <ng-template let-deposit pTemplate="item">
                  <div class="text-sm">{{deposit.value}}</div>
              </ng-template>
          </p-select>
          <app-error-msg
              *ngIf=" SelectedOccurenceTypeFormControl?.touched && SelectedOccurenceTypeFormControl?.invalid "
              [errors]="SelectedOccurenceTypeFormControl?.errors"
              [fieldLabel]="'DEPOSIT.OCCURENCE_TYPE' | translate"
          ></app-error-msg>
      </div>
      <!-- Selectbox for Mobile -->

      <!-- Deposit Type 1 -->
      <div class="mt-3">
          <div class="flex align-items-center text-600">
              <i class="fa fa-info-circle mr-2"></i>
              <p class="text-xs mb-0">{{"DEPOSIT.INFO."+SelectedOccurenceTypeFormControl.value.value | translate }}</p>
          </div>

          <div class="mt-4 pt-2" *ngIf="(SelectedOccurenceTypeFormControl.value.value !== GetOccurenceType.ApplyManually && SelectedOccurenceTypeFormControl.value.value.toString() !== GetOccurenceType[GetOccurenceType.ApplyManually])">
              <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'DEPOSIT.OCCURRENCE' | translate}}</label>
              <p-select [options]="occurences" optionLabel="key" filterBy="key"  optionDisabled="selected"
                formControlName="occurence" styleClass="w-full text-sm" placeholder="Select...">
                  <ng-template pTemplate="selectedItem">
                      <div class="text-sm" *ngIf="SelectedOccurenceFormControl.value">
                          {{SelectedOccurenceFormControl.value.key}}
                      </div>
                  </ng-template>
                  <ng-template let-occurence pTemplate="item">
                      <div class="text-sm">{{occurence.key}}</div>
                  </ng-template>
              </p-select>
              <app-error-msg *ngIf="SelectedOccurenceFormControl?.touched && SelectedOccurenceFormControl?.invalid " [errors]="SelectedOccurenceFormControl?.errors" [fieldLabel]="'DEPOSIT.OCCURRENCE' | translate"></app-error-msg>
          </div>

          <div class="flex align-items-center mt-3 ml-3 pl-2" *ngIf="SelectedOccurenceTypeFormControl.value.value == GetOccurenceType.ApplyManually ||  SelectedOccurenceTypeFormControl.value.value.toString() == GetOccurenceType[GetOccurenceType.ApplyManually]">
            <p-toggleSwitch formControlName="add_occurence" [ngClass]="{ 'ng-invalid ng-dirty': AddOccurenceFormControl.invalid && AddOccurenceFormControl.touched }"></p-toggleSwitch>
            <p class="text-sm mb-0 ml-3 -mt-1">{{'common.BUTTONS.BTN_ADD_DEPOSIT' | translate}}</p>
          </div>

      </div>
      <!-- Deposit Type 1 -->
  </div>
  <!-- Modal Content -->

  <!-- Modal Footer -->
  <div class="p-3 flex align-items-center justify-content-between surface-0 sticky left-0 bottom-0 w-full z-1 border-top-1 border-300">
      <p-button [label]="'ADMIN.COMMON.CANCEL' | translate" styleClass="p-button-link text-sm" (click)="closeDialog()"></p-button>
      <p-button styleClass="text-sm" type="submit" [disabled]="!depositOccurenceForm.valid || !isValidDeposit()" [label]="'common.BUTTONS.BUTTON-TEXT-SAVE' | translate"></p-button>
  </div>
  <!-- Modal Footer -->
</form>

<!-- Add Deposits Modal -->
